import { createSelector } from '@reduxjs/toolkit';

import { payloadSel } from '@location';
import { packRosterItemsSel, urlUserIdSel } from '@shared';

export const activityTypeIdSel = state => payloadSel(state).activityType;

export const adultDetailsSel = createSelector(
  urlUserIdSel,
  packRosterItemsSel,
  (userId, rosterItems) => {
    const foundPerson = rosterItems.find(person => person.userId == userId);
    return foundPerson || {};
  },
);

export const isAdultWithinUnitSel = createSelector(
  urlUserIdSel,
  packRosterItemsSel,
  (userId, packRoster) => !!packRoster.find(item => item.userId == userId),
);
